import { Box, Cluster, Stack } from './layouts';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';
import { useContext } from 'react';
import WhiteLabelContext from '../../context/WhiteLabelContext';
import QRCode from 'react-qr-code';

const DownloadAppModal = ({
  showDownloadAppModal,
  setShowDownloadAppModal,
  appInfo
}) => {
  const { t } = useTranslation();
  let { host } = useContext(WhiteLabelContext);
  host = host ? `https://${host}` : 'https://eigenaar.uwkluis.nl';

  return (
    <Modal
      isOpen={showDownloadAppModal}
      onRequestClose={() => setShowDownloadAppModal(false)}
    >
      <Stack space="l">
        <Box fontScale="xl" fontWeight="bold">
          {t('Download de {{app_name}} app', { app_name: appInfo.app_name })}
        </Box>
      </Stack>
      <Cluster mt="xl" display="flex" justifyContent="center" hGap="m">
        <QRCode
          value={`${host}/download-app?android_app=${appInfo.play_store_link}&ios_app=${appInfo.app_store_link}`}
        />
      </Cluster>
      <Cluster mt="xl" display="flex" justifyContent="center" hGap="m">
        <div style={{ display: 'flex-row' }}>
          <ClickableDownloadIcons appInfo={appInfo} />
        </div>
      </Cluster>
    </Modal>
  );
};

export const ClickableDownloadIcons = ({ appInfo }) => (
  <>
    <a
      href={`https://${appInfo.play_store_link}?referrer=downloadViaWebTest`}
      target="_blank"
      rel="noreferrer"
      style={{ display: 'inline-block', overflow: 'visible' }}
    >
      <GoogleIcon />
    </a>
    <a
      onClick={async e => {
        e.preventDefault();
        await window.navigator.clipboard.writeText(appInfo.referrer);
        window.open(`https://${appInfo.app_store_link}`)
      }}
      target="_blank"
      rel="noreferrer"
      style={{ display: 'inline-block', overflow: 'hidden' }}
    >
      <AppleIcon />
    </a>
  </>
);

export const GoogleIcon = ({ onClick = () => null }) => {
  const { t } = useTranslation();
  return (
    <img
      src="https://play.google.com/intl/en_us/badges/static/images/badges/nl_badge_web_generic.png"
      alt={t('Ontdek het op Google Play')}
      style={{
        borderRadius: '13px',
        height: '67px',
        marginRight: '25px'
      }}
      onClick={onClick}
    />
  );
};

export const AppleIcon = ({ onClick = () => null }) => {
  const { t } = useTranslation();
  return (
    <img
      src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1662940800&h=fdcf81d630c8693a62daa599b7618e50"
      alt={t('Download on the App Store')}
      style={{ borderRadius: '13px', height: '54px' }}
      onClick={onClick}
    />
  );
};

export default DownloadAppModal;
